import { Box, ButtonBase, Tooltip, Typography } from "@mui/material";
import LanguageRoundedIcon from "@mui/icons-material/LanguageRounded";
import { LANGUAGES, useLanguage } from "../context/LanguageContext";

const OPTIONS = [
  { value: LANGUAGES.ENGLISH, shortLabel: "EN", nameKey: "language.name.en" },
  { value: LANGUAGES.GREEK, shortLabel: "ΕΛ", nameKey: "language.name.el" },
];

export default function LanguageSwitcher({ light = false, sx }) {
  const { language, setLanguage, t } = useLanguage();
  const nextLanguage = language === LANGUAGES.GREEK ? LANGUAGES.ENGLISH : LANGUAGES.GREEK;

  return (
    <Tooltip
      arrow
      title={
        nextLanguage === LANGUAGES.GREEK
          ? t("language.switchToGreek")
          : t("language.switchToEnglish")
      }
    >
      <Box
        role="group"
        aria-label={t("language.selector")}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.35,
          p: 0.35,
          borderRadius: 999,
          border: "1px solid",
          borderColor: light ? "rgba(255,255,255,0.58)" : "divider",
          bgcolor: light ? "rgba(255,255,255,0.18)" : "background.paper",
          boxShadow: light
            ? "0 4px 14px rgba(15,23,42,0.14)"
            : "0 5px 18px rgba(15,23,42,0.10)",
          backdropFilter: "blur(12px)",
          ...sx,
        }}
      >
        <LanguageRoundedIcon
          aria-hidden="true"
          sx={{
            ml: 0.65,
            mr: 0.2,
            fontSize: 17,
            color: light ? "inherit" : "primary.main",
          }}
        />
        {OPTIONS.map((option) => {
          const selected = language === option.value;
          return (
            <ButtonBase
              key={option.value}
              aria-label={t(option.nameKey)}
              aria-pressed={selected}
              onClick={() => setLanguage(option.value)}
              sx={{
                minWidth: 35,
                height: 28,
                px: 0.9,
                borderRadius: 999,
                color: selected
                  ? "#fff"
                  : light
                    ? "inherit"
                    : "text.secondary",
                bgcolor: selected ? "primary.main" : "transparent",
                boxShadow: selected ? "0 3px 9px rgba(11,77,162,0.28)" : "none",
                transition: "background-color 160ms ease, color 160ms ease, box-shadow 160ms ease",
                "&:hover": {
                  bgcolor: selected ? "primary.main" : "action.hover",
                },
                "&.Mui-focusVisible": {
                  outline: "2px solid",
                  outlineColor: "primary.main",
                  outlineOffset: 2,
                },
              }}
            >
              <Typography
                component="span"
                sx={{ fontSize: 11.5, lineHeight: 1, fontWeight: 800, letterSpacing: "0.05em" }}
              >
                {option.shortLabel}
              </Typography>
            </ButtonBase>
          );
        })}
      </Box>
    </Tooltip>
  );
}
